var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "flex flex-row gap-4 items-top customContainer pt-5 sm:pt-2 pb-2 justify-flex-start items-flex-start flex-wrap xl:flex-wrap",
    },
    [
      [
        _c(
          "div",
          {
            staticClass:
              "flex flex-col items-top gap-4 sm:flex-row flex-wrap custom-responsive",
          },
          [
            _c("FormGroup", {
              key: "item1",
              attrs: {
                title: "",
                type: "search",
                iconStyle: "customIcon",
                inputClass: "customFormInput fullwidthAssignee fullWidthNew",
                placeholder: "Search by Client name",
                debounceTime: 500,
              },
              model: {
                value: _vm.title,
                callback: function ($$v) {
                  _vm.title = $$v
                },
                expression: "title",
              },
            }),
            _c(
              "FormGroup",
              { key: "item5", staticClass: "mb-2" },
              [
                _c("FormDatepicker", {
                  attrs: {
                    iconStyle: "customIcon",
                    inputClass: "customFormInput",
                    calendarClass:
                      "right-0 sm:right-0 sm:left-auto left-0 sm:left-auto w-full",
                    customInputClass: "rounded-lg text-storm-gray text-sm h-1",
                    label: "",
                    placeholder: "Visit date",
                  },
                  model: {
                    value: _vm.createdAt,
                    callback: function ($$v) {
                      _vm.createdAt = $$v
                    },
                    expression: "createdAt",
                  },
                }),
              ],
              1
            ),
            _c(
              "FormGroup",
              { key: "item2" },
              [
                _c("ContractorsMultiselect", {
                  key: "item2",
                  attrs: {
                    value: _vm.filters.contractors,
                    getParentcontainerStyle:
                      "customWidthMax smallHeight w-full",
                    placeholder: "Search for an assignee name",
                    multiple: "",
                    contractorsConditions: _vm.contractorsMultiselectConditions,
                    debounceTime: 1000,
                  },
                  on: {
                    input: (chosenContractors) =>
                      (_vm.filters.contractors = chosenContractors),
                  },
                }),
              ],
              1
            ),
            !_vm.hideAddressFilter
              ? _c("FormGroup", {
                  key: "item4",
                  attrs: {
                    title: "",
                    type: "search",
                    iconStyle: "customIcon",
                    inputClass: "customFormInput fullWidthNew",
                    placeholder: "Search by address",
                    debounceTime: 500,
                  },
                  model: {
                    value: _vm.location,
                    callback: function ($$v) {
                      _vm.location = $$v
                    },
                    expression: "location",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pr-4" },
          [
            _c("UiButtonMessage", {
              attrs: {
                buttonClass: "customAdd",
                buttonText: "Reset",
                textClass: "customText customOnlyText",
              },
              on: { click: _vm.handleReset },
            }),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }